export default {
    // START:: SET FILTERED PRODUCTS DATA
    setFilteredProductsData(context, payload) {
        context.commit("setFilteredProductsData", payload);
    },
    // END:: SET FILTERED PRODUCTS DATA
};
